import React from 'react';
import { green_900, white } from '@fiverr-private/sass/helpers';
import { BadgePropsWithoutTooltip } from '../../types';
import Badge from '../Badge';

const BuyItAgainBadge = ({ dataTestId }: BadgePropsWithoutTooltip) => (
  <Badge color={white} backgroundColor={green_900} dataTestId={dataTestId} fontVariant="all_caps">
    <p>BUY IT AGAIN</p>
  </Badge>
);

BuyItAgainBadge.displayName = 'BuyItAgainBadge';

export default BuyItAgainBadge;
